import translate from '../plugins/translate'

const state = {
    filters: localStorage.getItem('callFilters') ? 
        JSON.parse(localStorage.getItem('callFilters')) : 
        {
            ID:{label:'ID', title:translate('Nº', 'AtendimentosTable'), values:[]},
            ACAO_COM_USUARIO_ID: {label:'ACAO_COM_USUARIO_ID', title:translate('Ação Com', 'AtendimentosTable'), values:[], exception: false},
            CLIENTE_ID: {label:'CLIENTE_ID', title:translate('Cliente', 'AtendimentosTable'), values:[], exception: false},
            DATA_INICIO: {label:'DATA_INICIO', title:translate('Dt. Ini.', 'AtendimentosTable'), values:[]},
            DATA_LIMITE: {label:'DATA_LIMITE', title:translate('Dt. Limite', 'AtendimentosTable'), values:[]},
            SOLICITANTE_ID: {label:'SOLICITANTE_ID', title:translate('Solicitante', 'AtendimentosTable'), values:[], exception: false},
            RESPONSAVEL_ID: {label:'RESPONSAVEL_ID', title:translate('Responsável', 'AtendimentosTable'), values:[], exception: false},
            SITUACAO_ID: {label:'SITUACAO_ID', title:translate('Situação', 'AtendimentosTable'), values:[], exception: false},
            NAO_LIDOS: {label:'NAO_LIDOS', title:translate('Não lidos', 'AtendimentosTable'), values:[]},
            TEXTO_MENSAGEM: {label: 'TEXTO_MENSAGEM', title:translate('Termo mensagem', 'AtendimentosTable'), values:[]},
            SETOR_ID: {label: 'SETOR_ID', title:translate('Setor', 'AtendimentosTable'), values:[], exception: false},
        },
    filterOptions: localStorage.getItem('callFilterOptions') ? 
        JSON.parse(localStorage.getItem('callFilterOptions')) :
        {
            clients: [],
            responsibles: [],
            calls: [],
            callRequesters: [],
            callResponsibles: [],
            situations: [],
            sections: []
        } ,
    filterValues: localStorage.getItem('callFilterValues') ? JSON.parse(localStorage.getItem('callFilterValues')) : []
}

const getters = {
    filters(state) {
        return state.filters
    },
    filterOptions(state) {
        return state.filterOptions
    },
    filterValues(state) {
        return state.filterValues
    }
}

const actions = {
    setFilters({commit}, filters){
        commit('FILTERS', filters)
    },
    setFilterOptions({commit}, filterOptions){
        commit('FILTER_OPTIONS', filterOptions)
    },
    setFilterValues({commit}, filterValues){
        commit('FILTER_VALUES', filterValues)
    }
}

const mutations = {
    FILTERS(state, filters) {
        state.filters = filters
        localStorage.setItem('callFilters', JSON.stringify(filters))
    },
    FILTER_OPTIONS(state, filterOptions){
        state.filterOptions = filterOptions
        localStorage.setItem('callFilterOptions', JSON.stringify(filterOptions))
    },
    FILTER_VALUES(state, filterValues){
        state.filterValues = filterValues
        localStorage.setItem('callFilterValues', JSON.stringify(filterValues)) 
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
